import React from "react";
import HeaderAfterLogin from "../../../../containers/HeaderAfterLogin";
import Footer from "../../../../containers/Footer";
import TelegramIcon from "../../../../assets/images/telegramIcon.svg";
import WhatsappIcon from "../../../../assets/images/whatsappIcon.svg";
import { useSelector } from "react-redux";

const SupportCustomer = () => {
  const { appDetails } = useSelector((state) => state.app);
  return (
    <div>
      <div>
        <HeaderAfterLogin />
      </div>

      <main className="main">
        <div className="container p-0">
          <div className="support-header">
            <div className="favicon">
              {/* <img src={FavIcon} alt="favicon" width={35} /> */}
              <img src={appDetails?.LOGO_URL} alt="Logo" width={35} />
            </div>
            <div className="support-heading">
              <h4>Namastey!</h4>
              <p>
                We are always here to help. 24/7 Call and Chat Support is
                Available Now!
              </p>
            </div>
            <div className="chat-call-support">
              <div className="chat-box">
                <h2 class="sectionTitle border-0">Call Support</h2>
                <p>8618402219</p>
              </div>
              <div className="chat-box">
                <h2 class="sectionTitle border-0">Chat Support</h2>
                <ul>
                  <li>
                    <a
                      href={
                        appDetails?.TELEGRAM != ""
                          ? appDetails?.TELEGRAM
                          : "javascript:void(0)"
                      }
                      target={appDetails?.TELEGRAM != "" ? "_blank" : ""}
                    >
                      <img src={TelegramIcon} alt="telegram" />
                    </a>
                  </li>
                  <li
                    href={
                      appDetails?.WHATS_APP_URL != ""
                        ? `https://wa.me/${appDetails?.WHATS_APP_URL}`
                        : "javascript:void(0)"
                    }
                    target={appDetails?.WHATS_APP_URL != "" ? "_blank" : ""}
                  >
                    <img src={WhatsappIcon} alt="whatsapp" />
                  </li>
                </ul>
              </div>
              <div className="chat-box">
                <h2 class="sectionTitle border-0">Email Support</h2>
                <div className="email-section">
                  <p>Payment related queries</p>
                  <a href="mailto:payment.Kismatbets@gmail.com">
                    payment@Kismatbets.io
                  </a>
                </div>
                <div className="email-section">
                  <p>Offers related or all otherqueries</p>
                  <a href="mailto:info.Kismatbets@gmail.com">
                    info@Kismatbets.io
                  </a>
                </div>
              </div>
            </div>
          </div>
        </div>
      </main>

      <div>
        <Footer />
      </div>
    </div>
  );
};

export default SupportCustomer;
